import { graphqlSdk } from '../../../../Utils/graphql-client';
import { SupportedLanguage } from '../../../../Utils/graphql-sdk';

export const loadBookingEditBooking = async (
  bookingId: string,
  language: SupportedLanguage
) => {
  console.log('loadBookingEditBooking', bookingId);
  const booking = await graphqlSdk.bookingEdit_getBooking({ id: bookingId, language });
  return booking.getBooking;
};
